import React from 'react'
import { StyledDivProps } from '../types'
import { classNames } from '../utils'

interface blackWrapperProps {
  children: React.ReactNode
  largePadding?: boolean
}

export const SlopedGradient = ({ children, customClasses }: StyledDivProps) => (
  <div
    className={classNames(
      'flex w-full origin-top-left -translate-y-4 skew-y-2 flex-col items-center bg-gradient-to-br from-primary-900 to-primary-500',
      customClasses
    )}
  >
    {children}
  </div>
)

export const PurpleWrapper = ({ children, customClasses }: StyledDivProps) => (
  <div
    className={classNames(
      'flex flex-col rounded-2xl bg-gradient-to-br from-primary-900 to-primary-500 p-8 sm:p-12',
      customClasses
    )}
  >
    {children}
  </div>
)

export const BlackWrapper = ({ children, largePadding }: blackWrapperProps) => (
  <div
    className={classNames(
      largePadding ? 'p-l sm:p-15' : 'p-l sm:p-xxl',
      'col-span-full flex h-auto w-full flex-col items-start rounded-2xl bg-default-900'
    )}
  >
    {children}
  </div>
)

export const gridColumns = `
  grid-cols-[1fr_repeat(12,_19px)_1fr]
  sm:grid-cols-[1fr_repeat(12,_32px)_1fr]
  md:grid-cols-[1fr_repeat(12,_40px)_1fr]
  lg:grid-cols-[1fr_repeat(12,_55px)_1fr]
  xl:grid-cols-[1fr_repeat(12,_70px)_1fr]
  2xl:grid-cols-[1fr_repeat(12,_98px)_1fr]
`

export const gridXGaps = `
  gap-x-2
  sm:gap-x-3
  md:gap-x-4
  lg:gap-x-6
  xl:gap-x-7
`

export const gridYGaps = `
  gap-y-2
  sm:gap-y-3
  md:gap-y-4
  lg:gap-y-6
  xl:gap-y-7
`

export const HomepageGrid = ({ children }: StyledDivProps) => (
  <main
    className={classNames(
      `grid auto-rows-auto items-stretch bg-default-1000 pt-36 sm:grid-rows-[560px_auto_auto_auto_1150px] sm:pt-32`,
      gridColumns,
      gridXGaps
    )}
  >
    {children}
  </main>
)

export const CareersGrid = ({ children }: StyledDivProps) => (
  <main
    className={classNames(
      `grid auto-rows-auto items-stretch pt-36 sm:grid-rows-[560px_500px_750px_300px]`,
      gridColumns,
      gridXGaps
    )}
  >
    {children}
  </main>
)

export const ProductPageGrid = ({ children }: StyledDivProps) => (
  <main
    className={classNames(
      `grid auto-rows-auto grid-rows-[850px] items-stretch bg-default-1000 pt-36 sm:pt-32 md:grid-rows-[560px_200px]`,
      gridColumns,
      gridXGaps
    )}
  >
    {children}
  </main>
)
